var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"black","margin-bottom":"-100px","margin-top":"70px"}},[_c('div',[_c('img',{attrs:{"width":"100%","src":require("@/assets/mobile-hero-art.png")},on:{"load":_vm.scrollToTop}})])])}
var staticRenderFns = []

export { render, staticRenderFns }